import { getOverTime } from "@/services/overtime.service"
import { useQuery } from "@tanstack/react-query"

export const useOvertime = (
    period: string,
    refDate: Date,
    options?: { enabled?: boolean; companyId?: string } // options est l'objet contenant les options de la requête
) => {
    return useQuery({
        queryKey: ["overtime", period, refDate.toDateString(), options?.companyId], // period, refDate et companyId sont les paramètres de la requête
        queryFn: () => getOverTime(period, refDate, options?.companyId),
        enabled: options?.enabled ?? true,
    })
}